// /src/App.js
import React, { useState, useEffect } from 'react';
import IntroInputForm from './components/simulator/IntroInputForm';
import ModelComparisonSelector from './components/simulator/ModelComparisonSelector';
import Layout from './components/Layout';
import SimulatorComparisonChart from './components/simulator/SimulatorComparisonChart';
import SimulatorComparisonSummary from './components/simulator/SimulatorComparisonSummary';

import ModelTabs from './components/simulator/ModelTabs';
import { simulateModels } from './components/simulator/SimulatorEngine';

const initialParams = {
  propertyValue: 300000,
  propertyGrowthRate: 5,
  rentGrowthRate: 2,
  taxRate: 2.0,
  insuranceRate: 0.6,
  maintenancePercentOfRent: 8,
  rentPercent: 46.4,
  equityPercent: 57.2,
  goldStartPrice: 108,
  goldGrowthRate: 8.8,
  stockGrowthRate: 10,
  // businessRevenueGrowthRate: 20,
  // businessAppreciationMultiple: 3,
  interestRate: 5,
  reinvestmentSplit: 100,
  vacancyRate: 7,
  adminFeePercent: 8,
  termYears: 20,
  sellCostRate: 6,
  monthlyRentRatio: 180,
  monthlyInvestmentAmount: 0,
};

function App() {
  const [params, setParams] = useState(initialParams);
  const [audience, setAudience] = useState('Investor');
  const [preferredModel, setPreferredModel] = useState('Rent-to-Own + Gold');
  const [investorResults, setInvestorResults] = useState([]);
  const [borrowerResults, setBorrowerResults] = useState([]);
  const [yearlyBreakdowns, setYearlyBreakdowns] = useState({});
  const [selectedModels, setSelectedModels] = useState([preferredModel]);

  useEffect(() => {
    if (!selectedModels || selectedModels.length === 0) return;
  
    const reorderedModels = [preferredModel, ...selectedModels.filter(m => m !== preferredModel)];
  
    const newInvestorResults = [];
    const newBorrowerResults = [];
    const newYearlyBreakdowns = {};
  
    reorderedModels.forEach((modelName) => {
      const { investorResult, borrowerResult, yearlyData } = simulateModels({ ...params, modelName });
  
      newInvestorResults.push({ model: modelName, ...(investorResult || {}) });
      newBorrowerResults.push({ model: modelName, ...(borrowerResult || {}) });
      newYearlyBreakdowns[modelName] = yearlyData;
    });
  
    setInvestorResults(newInvestorResults);
    setBorrowerResults(newBorrowerResults);
    setYearlyBreakdowns(newYearlyBreakdowns);
  }, [params, selectedModels, preferredModel, audience]);
  



  useEffect(() => {
    const newModels = audience === 'Investor'
      ? [
       'Traditional Rental','Bank Lending', 'Rent-to-Own', 'Rent-to-Own + Gold', 'Rent-to-Own + Real Estate',
       'Rent-to-Own + Stock', 'Gold Investment', 'Stock Investment'
      ]
      : [
       'Traditional Rental','Bank Lending', 'Rent-to-Own', 'Rent-to-Own + Gold', 'Rent-to-Own + Real Estate',
       'Rent-to-Own + Stock', 'Gold Investment', 'Stock Investment'
      ];

    setSelectedModels(newModels);
  }, [audience]);

  useEffect(() => {
    if (!preferredModel || !selectedModels.includes(preferredModel)) return;
  
    const reordered = [
      preferredModel,
      ...selectedModels.filter((m) => m !== preferredModel)
    ];
  
    setSelectedModels(reordered);
  }, [preferredModel]);
  

  const availableModels = audience === 'Investor'
    ? [
      'Traditional Rental','Bank Lending', 'Rent-to-Own', 'Rent-to-Own + Gold', 'Rent-to-Own + Real Estate',
       'Rent-to-Own + Stock', 'Gold Investment', 'Stock Investment'
    ]
    : [
      'Traditional Rental','Bank Lending', 'Rent-to-Own', 'Rent-to-Own + Gold', 'Rent-to-Own + Real Estate',
       'Rent-to-Own + Stock', 'Gold Investment', 'Stock Investment'
    ];

  return (
    <Layout>
    <div className="max-w-7xl mx-auto p-6 space-y-8">
      {/* <h1 className="text-3xl font-bold text-center text-blue-800 mb-4">
        NestQuest ROI Investment Simulator
      </h1> */}

      <IntroInputForm
        params={params}
        setParams={setParams}
        audience={audience}
        setAudience={setAudience}
        preferredModel={preferredModel}
        setPreferredModel={setPreferredModel}
        setSelectedModels={setSelectedModels}
      />



      <div className="bg-white p-6 md:p-8 rounded-lg shadow-md max-w-5xl mx-auto text-gray-800 space-y-6 leading-relaxed">


        <ModelTabs
          key={audience}
          investorResults={investorResults}
          borrowerResults={borrowerResults}
          yearlyBreakdowns={yearlyBreakdowns}
          params={params}
          selectedModel={preferredModel}
        />


        <ModelComparisonSelector
          availableModels={availableModels}
          selectedModels={selectedModels}
          setSelectedModels={setSelectedModels}
        />

        {/* <SimulatorComparisonSummary
          selectedModel={preferredModel}
          investorResults={investorResults}
          borrowerResults={borrowerResults}
          audience={audience}
        /> */}

        <SimulatorComparisonChart
          investorResults={investorResults}
          borrowerResults={borrowerResults}
          selectedModels={selectedModels}
          params={params}
        />

      </div>
    </div>
    </Layout>
  );
}

export default App;
